import EZO_I2C	from "../ezo_i2c.js";
import semver from "semver";
import sleep from "sleep";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "-";
    this.calibrationStatus = "-";        
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x63);      
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");
      this.slope = await this.command("Slope,?");
      this.firmwareVersion = await this.getFirmwareVersion();

      //TODO: lock to i2c
      //await this.command("Plock,1");
      //await sleep(1000);
      //console.log( await this.command("Plock,?") );
      

      this.usbProductName = "ezo_ph";
	  this.usbSerialNumber = "0x63";    
      this.name = "ezophSensor";
            
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  async update(devices) {
    var T;
    if (devices.temperatureSensor)
      T = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      T = devices.ezortdSensor.value;

    /* 
      from firmware version 2.12 we can use the RT command:
      RT,n set temperature compensation and take a reading
    */

    //var firmwareVersion = await this.getFirmwareVersion();    
    //firmwareVersion+=".0"; //semver does not like 2.12, he expects 2.12.0
    /*
      If the semver string a is greater than b, return 1. 
      If the semver string b is greater than a, return -1. If a equals b, return 0;
    */
    if (semver.compare(this.firmwareVersion, "2.12.0")>=0) {
      this.value = parseFloat( await this.command(`RT,${T?T:25}`) );   
    } else {
      await this.command(`T,${T?T:25}`);
      this.value = await this.command("R");      
    }             
    
    //repeated query for the following commands caused the pH measurement to return always the same value. measurement stucked
    //this.calibrationStatus = await this.command("Cal,?");
    //this.slope = await this.command("Slope,?");    
  } 
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");          
  }
  async calibrateTo4() {
    await this.command("Cal,low,4.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo7() {
    await this.command("Cal,mid,7.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo10() {
    await this.command("Cal,high,10.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async RM_clearCalibration() {
    await this.clearCalibration();
  }
  async RM_calibrateTo4() {
    await this.calibrateTo4();
  }
  async RM_calibrateTo7() {
    await this.calibrateTo7();
  }
  async RM_calibrateTo10() {
    await this.calibrateTo10();
  }  
  toJSON() {
    return({
      name: this.name,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,                  
      status: this.status,
      id: this.id,      
      value: this.value,
      calibrationStatus: this.calibrationStatus,
      slope: this.slope      
    });
  }
}

export default Module;